import { ERROR_MESSAGES } from "./errorCodes";

export function setupInterceptors(axiosInstance, showError) {
  axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response) {
        const code = error.response.data.code;
        const message = ERROR_MESSAGES[code] || "Ocurrió un error inesperado.";
        showError(message);
      } else {
        showError("No se pudo conectar con el servidor.");
      }

      return Promise.reject(error);
    }
  );
}
